export default "__VITE_ASSET__BI6Nc39W__"